/**
 * Redux witness watchers for testarossa
 * @module services/testrossa/watchers
 */
import { Map } from 'immutable'
import { getProjects, getCampaign } from '.'
import {
  GET_TESTAROSSA_PROJECTS,
  GET_TESTAROSSA_CAMPAIGN,
  SET_TESTAROSSA_CAMPAIGNS_ERROR,
  SET_TESTAROSSA_CAMPAIGN_DATA,
  SET_TESTAROSSA_PROJECTS_DATA,
  SET_TESTAROSSA_PROJECTS_ERROR,
} from './redux/actions'

/**
 * Get all testarossa projects
 * @param {Object} options The options
 * @param {Function} options.takeEvery Take every witness function
 */
export function onGetTestarossaProjects ({ takeEvery }) {
  return takeEvery(GET_TESTAROSSA_PROJECTS, async ({ state }) => {
    const { config = Map(), auth = Map() } = state
    const projects = await getProjects({
      auth,
      server: config.getIn(['data', 'servers', 'testarossa']),
    })
    return {
      type: SET_TESTAROSSA_PROJECTS_DATA,
      payload: {
        // Convert project list to a map keyed by uuid
        data: projects.reduce((acc, v) => acc.set(v.get('uuid'), v), Map()),
        processing: false,
      },
    }
  })
    .when(({ state }) => {
      const { testarossa } = state
      const processing = testarossa.getIn(['projects', 'processing'])
      return !processing
    })
    .retry(3, 500)
    .catch((_options, error) => ({
      type: SET_TESTAROSSA_PROJECTS_ERROR,
      payload: { error },
    }))
}

/**
 * Get one testarossa campaign
 * @param {Object} options The options
 * @param {Function} options.takeEvery Take every witness function
 */
export function onGetTestarossaCampaign ({ takeEvery }) {
  return takeEvery(GET_TESTAROSSA_CAMPAIGN, async ({ state, action }) => {
    const { payload: { uuid } = {} } = action
    const { config = Map(), auth = Map() } = state
    const campaign = await getCampaign({
      uuid,
      auth,
      server: config.getIn(['data', 'servers', 'testarossa']),
    })
    return {
      type: SET_TESTAROSSA_CAMPAIGN_DATA,
      payload: {
        uuid,
        data: campaign,
        processing: false,
      },
    }
  })
    .retry(3, 500)
    .when(({ state, action }) => {
      const { payload: { uuid } = {} } = action
      const { testarossa } = state
      return !testarossa.getIn(['campaigns', 'data', uuid])
    })
    .catch((_options, error) => ({
      type: SET_TESTAROSSA_CAMPAIGNS_ERROR,
      payload: { error },
    }))
}
